import { parseAgrEnvironment } from '@next/core-lib/environment';
import { RoughagePlusEnvironment } from 'src/environments/environment.model';

export const parseRoughagePlusEnvironment = (
  config: Record<string, string>,
): RoughagePlusEnvironment => {
  const baseEnvironment = parseAgrEnvironment(config);
  return {
    ...baseEnvironment,
    LEAD_SIGNUP_POLICY: config['LEAD_SIGNUP_POLICY'] || '',
    EMPLOYEE_SIGNIN_POLICY: config['EMPLOYEE_SIGNIN_POLICY'] || '',
    ENABLE_SILAGE_SOIL: config['ENABLE_SILAGE_SOIL'] === 'true',
    ENABLE_SOIL: config['ENABLE_SOIL'] === 'true',
    ENABLE_TELEMETRY: config['ENABLE_TELEMETRY'] === 'true',
  };
};
